import { useAuth } from '../hooks/useAuth';
import { Gallery } from '../components/Gallery';
import { Layout } from '../components/Layout';
import { useStatus } from '../hooks/useStatus';

export function GalleryPage() {
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const { isExpired, maintenanceMode, maintenanceMessage } = useStatus();

  if (authLoading) {
    return (
      <Layout showHeader={false}>
        <div className="loading-screen">
          <div className="spinner spinner-lg"></div>
          <p>Prüfe Anmeldung...</p>
        </div>
      </Layout>
    );
  }

  if (!isAuthenticated) {
    return null; // Will be redirected by router
  }

  return (
    <Layout>
      {maintenanceMode && (
        <div className="maintenance-banner" role="alert">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          <span>{maintenanceMessage || 'Die Galerie befindet sich im Wartungsmodus.'}</span>
        </div>
      )}

      {isExpired && (
        <div className="expired-banner" role="alert">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
          <span>Die Nutzungsfrist ist abgelaufen. Die Galerie ist im Lesemodus.</span>
        </div>
      )}

      <div className="gallery-page">
        <Gallery />
      </div>
    </Layout>
  );
}